
<p-table [columns]="resultsCols" stripedRows [value]="results">
    <ng-template #header let-columns pTemplate="frozenheader">
        <tr>
            <th *ngFor="let col of columns" pResizableColumn pSortableColumn={{col.field}}>
                {{ col.header }}
            <p-sortIcon field={{col.field}}></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                {{ rowData[col.field] }}
            </td>
        </tr>
    </ng-template>
</p-table>
